export const useSearchMixins = () => {

    const defaultSearch = {
        options: {
            resultsPerPage: 10,
            minimumSearchQueryLength: 2,
        },
    };

    return {
        defaultSearch
    };
};
